import SchedulingMapEventView from './SchedulingMapEventView';

export default SchedulingMapEventView;